const actions = {
  // Ficha de EPI
  listarUsuarios: async (context, { vendor_id, per_page, search, deleted }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`auth/users`, {
      params: {
        per_page,
        vendor_id,
        search,
        deleted,
      },
    });
    return response;
  },

  listarUsuariosPorUnidade: async (
    context,
    { vendor_id, per_page, page, search, cost_center_id, function_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`auth/users`, {
      params: {
        per_page,
        page,
        vendor_id,
        search: search || "",
        deleted: "",
        cost_center_id: cost_center_id || undefined,
        function_id: function_id || undefined,
      },
    });
    return response;
  },

  listarDadosFichaEpi: async (
    context,
    {
      dataFinal,
      dataInicial,
      epi,
      per_page,
      solicitanteId,
      solicitanteSap,
      RequisicaoAutenticacao = true,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ficha-epi`, {
      params: {
        dataFinal,
        dataInicial,
        epi,
        per_page,
        solicitanteId,
        solicitanteSap,
        RequisicaoAutenticacao,
      },
    });
    return response;
  },

  alterarConfiguracaoAssinaturaRodape: async (
    context,
    { vendor_id, mostrar }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`ficha-epi/configuracao/rodape-assinatura`, {
      vendor_id,
      mostrar,
    });
    return response;
  },

  receberConfiguracaoAssinaturaRodape: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ficha-epi/configuracao/rodape-assinatura`);
    return response;
  },

  // Ficha EPI Impressão
  entregasUsuario: async (context, { solicitante_id, data_inicial }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ficha-epi/entregas-usuario`, {
      params: {
        solicitante_id,
        data_inicial,
      },
    });
    return response;
  },

  listarColunasUsuario: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ficha-epi/configuracao/info-usuario`, {
      params: {
        vendor_id,
      },
    });
    return response;
  },

  listarColunasTabela: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ficha-epi/configuracao/info-entrega`, {
      params: {
        vendor_id,
      },
    });
    return response;
  },

  getArquivos: async (context, { user_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`gestao-aquivo-epi/listagem-arquivos`, {
      params: {
        user_id,
      },
    });
    return response;
  },

  getDescricao: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/ficha-epi/configuracao/descricao`, {
      params: {
        vendor_id,
      },
    });
    return response;
  },
  getFichaLegado: async (
    context,
    {
      nome,
      matricula,
      dataInicial,
      dafaFinal,
      nome_relatorio = "usuario_legado_dexco",
      per_page,
      pagina,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`/cel/relatorio`, {
      params: {
        nome,
        matricula,
        dataInicial,
        dafaFinal,
        nome_relatorio,
        per_page,
        pagina,
      },
    });
    return response;
  },

  deletarArquivo: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`gestao-aquivo-epi/${uuid}`, {
      params: {
        uuid,
      },
    });
    return response;
  },

  subirArquivo: async (context, { imagem, user_id, descricao }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`gestao-aquivo-epi`, {
      arquivo: imagem,
      user_id,
      descricao,
    });
    return response;
  },
  baixarArquivo: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `gestao-aquivo-epi/gerar-link-temporario/${uuid}`
    );
    return response;
  },

  uploadImagemLogo: async (context, { imagem, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`vendors/${vendor_id}/modificar-logo`, {
      imagem,
    });
    return response;
  },

  baixarUsuarios: async (
    context,
    { group_type, group_id, data_inicial, data_final, vendor_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const mensagem = {
      group_type,
      group_id,
      data_inicial,
      data_final,
    };

    if (vendor_id !== undefined) {
      mensagem.vendor_id = vendor_id;
    }

    const response = await api.post(`ficha-epi/solicitar-download`, {
      mensagem,
    });

    return response;
  },
  getConsultaExportFicha: async (
    context,
    {
      perPage,
      page,
      id,
      agrupador,
      agrupadorId,
      status,
      webhook,
      filtros,
      arquivo,
      numeroFuncionarios,
      criadoEmInicial,
      criadoEmFinal,
    }
  ) => {
    const api = context.rootState.autenticacao.apiExportFicha;

    const response = await api.get(`ficha`, {
      params: {
        perPage,
        page,
        id,
        agrupador,
        agrupadorId,
        status,
        webhook,
        filtros,
        arquivo,
        numeroFuncionarios,
        criadoEmInicial,
        criadoEmFinal,
      },
    });
    return response;
  },

  listarCentrosCusto: async (
    context,
    { vendor_id, search, per_page = 10, page = 0 }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cost-centers`, {
      params: { per_page, vendor_id, page, search },
    });
    return response;
  },

  listarFuncoes: async (
    context,
    { vendor_id, search, per_page = 10, page = 0 }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`functions`, {
      params: { page, per_page, vendor_id, search },
    });
    return response;
  },

  getExportFichaEpiStatus: async (
    context,
    { userId, status, startDate, endDate, per_page = 10, page = 0 } = {}
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`ficha-epi/export-ficha-epi/status`, {
      params: {
        userId: userId || undefined,
        status: status || undefined,
        startDate: startDate || undefined,
        endDate: endDate || undefined,
        per_page,
        page,
      },
    });
    return response;
  },
};

export const seguranca = {
  namespaced: true,
  actions,
};
